/**
 * @enum {String}
 * @type {{ADMIN: string, ADMINISTRATOR: string, MARKETING: string,NPOS: string, HRD: string, 
 *         COMMUNITY: string, QC: string, SALES: string, EXTERNAL: string, STAFF: string, LEAD: string}}
 */
 const ACCOUNT_GROUP = {
    ADMIN: "ADMIN",
    ADMINISTRATOR: "ADMINISTRATOR",
    NPOS: "NPOS",
    MARKETING: "MARKETING",
    HRD: "HRD",
    COMMUNITY: "COMMUNITY",
    QC: "QC",
    SALES: "SALES",
    EXTERNAL: "EXTERNAL",
    STAFF: "STAFF",
    LEAD: "LEAD"
}

export default ACCOUNT_GROUP